import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { SerialNumber } from '../interfaces/serialNumber';

export const serialNumbersService = {
  listSerials: (): Promise<SerialNumber[]> =>
    axiosService.get(`${AXIOS_URLS.serial_numbers}/`).then((res) => res.data),
  findSerial: (sn: string): Promise<SerialNumber> =>
    axiosService
      .get(`${AXIOS_URLS.serial_numbers}/${sn}`)
      .then((res) => res.data),
  excel: () =>
    axiosService
      .get(`${AXIOS_URLS.serial_numbers}/excel`, {
        responseType: 'blob',
      })
      .then((res) => res.data),
  update: (data: SerialNumber): Promise<SerialNumber> =>
    axiosService
      .patch(`${AXIOS_URLS.serial_numbers}/update`, data)
      .then((res) => res.data),
  getRegistrationHistory: (): Promise<SerialNumber[]> =>
    axiosService
      .get(`${AXIOS_URLS.serial_numbers}/registration-history`)
      .then((res) => res.data),
  getRegistrationHistoryExcel: () =>
    axiosService
      .get(`${AXIOS_URLS.serial_numbers}/registration-history/excel`, {
        responseType: 'blob',
      })
      .then((res) => res.data),
};
